import { render, staticRenderFns } from "./verbaleTecnicoGVR.vue?vue&type=template&id=611c6d81"
import script from "./verbaleTecnicoGVR.vue?vue&type=script&lang=js"
export * from "./verbaleTecnicoGVR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports